export const ControlSize = {
  Large: "Large",
  Medium: "Medium",
  Small: "Small",
};
